var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5217 5.65002L13.4217 3.25002C13.0217 2.85002 12.1217 2.65002 11.5217 2.65002H7.72169C6.52169 2.65002 5.22169 3.55002 4.92169 4.75002L2.52169 12.05C2.02169 13.45 2.92169 14.65 4.42169 14.65H8.42169C9.02169 14.65 9.52169 15.15 9.42169 15.85L8.92169 19.05C8.72169 19.95 9.32169 20.95 10.2217 21.25C11.0217 21.55 12.0217 21.15 12.4217 20.55L16.5217 14.45",
    stroke: "#697480",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6211 5.65V15.45C21.6211 16.85 21.0211 17.35 19.6211 17.35H18.6211C17.2211 17.35 16.6211 16.85 16.6211 15.45V5.65C16.6211 4.25 17.2211 3.75 18.6211 3.75H19.6211C21.0211 3.75 21.6211 4.25 21.6211 5.65Z",
    stroke: "#697480",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.8eb89b7b3dd7d527bd65dd87b5df5fee.svg";
export { ForwardRef as ReactComponent };